(function () {
  'use strict';

  var section = document.querySelector('[data-hero-watch]');
  if (!section) return;

  var slides = section.querySelectorAll('[data-slide]');
  var tabs = section.querySelectorAll('[data-tab]');
  var imageWrapper = section.querySelector('[data-image-wrapper]');
  var textTrack = section.querySelector('[data-text-track]');
  var subtitleEl = section.querySelector('.hero-watch__subtitle');
  var taglineEl = section.querySelector('.hero-watch__tagline');

  var currentWatch = imageWrapper.querySelector('.hero-watch__watch');
  var currentText = textTrack.querySelector('.hero-watch__collection-name');

  var activeIndex = 0;
  var isAnimating = false;

  // ===== Spring physics: stiffness 34.95, damping 10, mass 1 =====
  var STIFFNESS = 34.95;
  var DAMPING = 10;
  var MASS = 1;
  var DURATION = 1200;

  var w0 = Math.sqrt(STIFFNESS / MASS);
  var zeta = DAMPING / (2 * Math.sqrt(STIFFNESS * MASS));
  var wd = w0 * Math.sqrt(1 - zeta * zeta);

  function springValue(t) {
    return 1 - Math.exp(-zeta * w0 * t) * (
      Math.cos(wd * t) + (zeta * w0 / wd) * Math.sin(wd * t)
    );
  }

  var SPRING_STEPS = 40;
  var springDurationSec = DURATION / 1000;
  var springFrames = [];
  for (var i = 0; i <= SPRING_STEPS; i++) {
    var t = (i / SPRING_STEPS) * springDurationSec;
    springFrames.push({
      offset: i / SPRING_STEPS,
      value: springValue(t),
    });
  }
  // Clamp last frame to exactly 1.0 so animation ends at precise target
  springFrames[springFrames.length - 1].value = 1;

  // Watch keyframes — single continuous curve
  function buildWatchKeyframes(startX, startY, startRot, startScale, startOp,
                                endX, endY, endRot, endScale, endOp) {
    return springFrames.map(function (frame) {
      var p = frame.value;
      var x = startX + (endX - startX) * p;
      var y = startY + (endY - startY) * p;
      var rot = startRot + (endRot - startRot) * p;
      var sc = startScale + (endScale - startScale) * p;
      var op = startOp + (endOp - startOp) * p;
      var curveY = -12 * 4 * p * (1 - p);
      return {
        transform: 'translate3d(' + x + '%, ' + (y + curveY) + '%, 0) rotate(' + rot + 'deg) scale(' + sc + ')',
        opacity: op,
        offset: frame.offset,
      };
    });
  }

  // Background text keyframes with spring
  function buildTextKeyframes(fromY, toY, fromOpacity, toOpacity) {
    var isMobile = window.innerWidth <= 1024;
    var tx = isMobile ? 'translateX(-50%) ' : '';
    return springFrames.map(function (frame) {
      var p = frame.value;
      var y = fromY + (toY - fromY) * p;
      var op = fromOpacity + (toOpacity - fromOpacity) * p;
      return {
        transform: tx + 'translateY(' + y + '%)',
        opacity: Math.max(0, Math.min(1, op)),
        offset: frame.offset,
      };
    });
  }

  // Collect slide data
  var slideData = Array.from(slides).map(function (slide) {
    return {
      name: slide.dataset.collectionName || '',
      subtitle: slide.dataset.subtitle || '',
      tagline: slide.dataset.tagline || '',
      color: slide.dataset.color || '#233C61',
      imageSrc: slide.querySelector('img') ? slide.querySelector('img').src : '',
    };
  });

  if (slideData.length > 0) {
    currentText.style.color = slideData[0].color;
    subtitleEl.style.color = slideData[0].color;
    taglineEl.style.color = slideData[0].color;
  }

  // Preload images
  slideData.forEach(function (data) {
    if (data.imageSrc) {
      var img = new Image();
      img.src = data.imageSrc;
    }
  });

  function switchCollection(newIndex) {
    if (newIndex === activeIndex || isAnimating) return;
    isAnimating = true;

    var data = slideData[newIndex];
    var direction = newIndex > activeIndex ? 1 : -1;

    tabs.forEach(function (tab) { tab.classList.remove('is-active'); });
    tabs[newIndex].classList.add('is-active');

    var ANGLE = 18.88;
    var OFF_SCALE = 0.626;
    var OFF_OPACITY = 0.88;

    // ===== 1. WATCH SLIDER =====
    var nextWatch = document.createElement('img');
    nextWatch.className = 'hero-watch__watch';
    nextWatch.src = data.imageSrc;
    nextWatch.alt = data.name;
    imageWrapper.appendChild(nextWatch);

    var exitKeyframes = buildWatchKeyframes(
      0, 0, 0, 1, 1,
      -direction * Math.min(280, window.innerWidth * 0.8), 0, -direction * ANGLE, OFF_SCALE, OFF_OPACITY
    );

    currentWatch.animate(exitKeyframes, {
      duration: DURATION,
      easing: 'linear',
      fill: 'forwards',
    });

    var enterKeyframes = buildWatchKeyframes(
      direction * Math.min(280, window.innerWidth * 0.8), 0, direction * ANGLE, OFF_SCALE, OFF_OPACITY,
      0, 0, 0, 1, 1
    );

    var enterAnim = nextWatch.animate(enterKeyframes, {
      duration: DURATION,
      easing: 'linear',
      fill: 'forwards',
    });

    // ===== 2. BACKGROUND TEXT — bottom to top with spring =====
    var nextText = document.createElement('span');
    nextText.className = 'hero-watch__collection-name';
    nextText.textContent = data.name;
    nextText.style.color = data.color;
    textTrack.appendChild(nextText);

    // Current text slides UP and out (0 → -120%)
    currentText.animate(
      buildTextKeyframes(0, -120, 1, 0),
      { duration: DURATION, easing: 'linear', fill: 'forwards' }
    );

    // New text slides UP into place from below (+120% → 0)
    nextText.animate(
      buildTextKeyframes(120, 0, 0, 1),
      { duration: DURATION, easing: 'linear', fill: 'forwards' }
    );

    // ===== 3. SUBTITLE + TAGLINE — cancel old anim before new one =====
    var FADE_OUT = DURATION * 0.25;
    var FADE_IN = DURATION * 0.4;

    var subOutAnim = subtitleEl.animate([
      { opacity: 1, transform: 'translateY(0)' },
      { opacity: 0, transform: 'translateY(12px)' },
    ], {
      duration: FADE_OUT,
      easing: 'cubic-bezier(0.4, 0, 1, 1)',
      fill: 'forwards',
    });

    var tagOutAnim = taglineEl.animate([
      { opacity: 1, transform: 'translateY(0)' },
      { opacity: 0, transform: 'translateY(-12px)' },
    ], {
      duration: FADE_OUT,
      easing: 'cubic-bezier(0.4, 0, 1, 1)',
      fill: 'forwards',
    });

    setTimeout(function () {
      // Cancel fade-out fill so it doesn't override fade-in
      subOutAnim.cancel();
      tagOutAnim.cancel();

      // Set opacity to 0 manually before swapping text
      subtitleEl.style.opacity = '0';
      taglineEl.style.opacity = '0';

      // Swap content and color
      subtitleEl.textContent = data.subtitle;
      taglineEl.textContent = data.tagline;
      subtitleEl.style.color = data.color;
      taglineEl.style.color = data.color;

      // Fade in
      var subInAnim = subtitleEl.animate([
        { opacity: 0, transform: 'translateY(-12px)' },
        { opacity: 1, transform: 'translateY(0)' },
      ], {
        duration: FADE_IN,
        easing: 'cubic-bezier(0, 0, 0.2, 1)',
        fill: 'forwards',
      });

      var tagInAnim = taglineEl.animate([
        { opacity: 0, transform: 'translateY(12px)' },
        { opacity: 1, transform: 'translateY(0)' },
      ], {
        duration: FADE_IN,
        easing: 'cubic-bezier(0, 0, 0.2, 1)',
        fill: 'forwards',
      });

      // Clean up inline styles when fade-in finishes
      subInAnim.onfinish = function () {
        subInAnim.commitStyles();
        subInAnim.cancel();
        subtitleEl.style.opacity = '';
        subtitleEl.style.transform = '';
      };
      tagInAnim.onfinish = function () {
        tagInAnim.commitStyles();
        tagInAnim.cancel();
        taglineEl.style.opacity = '';
        taglineEl.style.transform = '';
      };
    }, FADE_OUT + 80);

    // ===== Cleanup =====
    enterAnim.onfinish = function () {
      if (currentWatch.parentNode) currentWatch.remove();
      if (currentText.parentNode) currentText.remove();

      // Cancel animation — element returns to its natural CSS state
      // which matches the final position (no transform, opacity 1)
      enterAnim.cancel();

      currentWatch = nextWatch;
      currentText = nextText;
      activeIndex = newIndex;
      isAnimating = false;
    };
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      switchCollection(parseInt(tab.dataset.tab, 10));
      resetAutoPlay();
    });
  });

  section.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') {
      switchCollection((activeIndex + 1) % slideData.length);
      resetAutoPlay();
    } else if (e.key === 'ArrowLeft') {
      switchCollection((activeIndex - 1 + slideData.length) % slideData.length);
      resetAutoPlay();
    }
  });

  // ===== Touch Swipe (mobile) =====
  var touchStartX = 0;
  var touchStartY = 0;
  var SWIPE_THRESHOLD = 40;

  section.addEventListener('touchstart', function (e) {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  }, { passive: true });

  section.addEventListener('touchend', function (e) {
    var dx = e.changedTouches[0].clientX - touchStartX;
    var dy = e.changedTouches[0].clientY - touchStartY;
    if (Math.abs(dx) < SWIPE_THRESHOLD || Math.abs(dy) > Math.abs(dx)) return;
    if (dx < 0) {
      switchCollection((activeIndex + 1) % slideData.length);
    } else {
      switchCollection((activeIndex - 1 + slideData.length) % slideData.length);
    }
    resetAutoPlay();
  }, { passive: true });

  // ===== Auto-Play (3s interval) =====
  var AUTO_INTERVAL = 3000;
  var autoTimer = null;

  function startAutoPlay() {
    stopAutoPlay();
    autoTimer = setInterval(function () {
      if (!isAnimating) {
        switchCollection((activeIndex + 1) % slideData.length);
      }
    }, AUTO_INTERVAL);
  }

  function stopAutoPlay() {
    if (autoTimer) {
      clearInterval(autoTimer);
      autoTimer = null;
    }
  }

  function resetAutoPlay() {
    stopAutoPlay();
    startAutoPlay();
  }

  // Pause when section not visible
  var observer = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) {
      startAutoPlay();
    } else {
      stopAutoPlay();
    }
  }, { threshold: 0.3 });
  observer.observe(section);
})();
